module.exports = __webpack_public_path__ + "static/media/qa1.a4ebdbcb.avif";